import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_109: FaireProductEntity = {
  token: "catalog_prod_prod-109",
  type: "product",
  name: "Figurine - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1602874801007-bd458bb1b8b6?w=400&h=400&fit=crop",
  priceDollars: 62.22,
  msrpDollars: 155.55,
  sku: "CA0109",
  caseSize: 1,
  material: "Glass",
  collectionToken: "col_camp",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 92,
  description: "Beautiful Camp! piece perfect for any home.",
  categoryTokens: ["catalog_cat_wall-decor"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
